import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import FinancialReports from "./FinancialReports";
import { PaymentSettings } from "@/components/admin/settings/PaymentSettings";
import { AIFinanceAnalysis } from "@/components/admin/finance/AIFinanceAnalysis";
import { TransactionMonitoring } from "@/components/admin/finance/TransactionMonitoring";

const FinancialManagement = () => {
  return (
    <div className="space-y-6 p-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Financial Management</h1>
      </div>

      <Tabs defaultValue="reports" className="space-y-6">
        <TabsList className="grid grid-cols-4 w-full max-w-2xl">
          <TabsTrigger value="reports">Reports</TabsTrigger>
          <TabsTrigger value="transactions">Transactions</TabsTrigger>
          <TabsTrigger value="ai-analysis">AI Analysis</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>

        <TabsContent value="reports" className="space-y-6">
          <FinancialReports />
        </TabsContent>

        <TabsContent value="transactions" className="space-y-6">
          <TransactionMonitoring />
        </TabsContent>

        <TabsContent value="ai-analysis" className="space-y-6">
          <AIFinanceAnalysis />
        </TabsContent>

        <TabsContent value="settings" className="space-y-6">
          <PaymentSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default FinancialManagement;